import { useState } from "react";
import { motion } from "framer-motion";
import { SERVICES, CATEGORIES } from "../data/services";

export const ServicesSection = ({ onSelect }) => {
  const [filter, setFilter] = useState("ALL");
  const visible = filter === "ALL" ? SERVICES : SERVICES.filter((s) => s.category === filter);

  return (
    <section id="services" className="border-t border-olive-deep py-24 sm:py-32" data-testid="services-section">
      <div className="max-w-[1400px] mx-auto px-4 sm:px-8">
        <div className="flex flex-col lg:flex-row lg:items-end justify-between gap-8 mb-14">
          <div>
            <p className="overline-tactical text-coyote mb-4" data-testid="services-overline">OP-FIX // 02 // SERVICE OPERATIONS</p>
            <h2 className="font-display uppercase text-4xl sm:text-6xl tracking-tight text-foreground" data-testid="services-heading">
              Full Service <span className="text-khaki">Arsenal</span>
            </h2>
          </div>
          <div className="flex flex-wrap gap-2" data-testid="services-filters">
            {CATEGORIES.map((c) => (
              <button
                key={c}
                onClick={() => setFilter(c)}
                data-testid={`filter-${c.toLowerCase().replace(/\s+/g, "-")}`}
                className={`text-[11px] tracking-[0.2em] px-4 py-2 border transition-colors duration-300 ${
                  filter === c
                    ? "bg-khaki text-obsidian border-khaki font-bold"
                    : "border-olive-deep text-muted-foreground hover:text-khaki hover:border-khaki"
                }`}
              >
                {c}
              </button>
            ))}
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-12 gap-px bg-olive-deep border border-olive-deep" data-testid="services-grid">
          {visible.map((s, i) => {
            const Icon = s.icon;
            return (
              <motion.button
                key={s.code}
                onClick={() => onSelect(s.name)}
                initial={{ opacity: 0, y: 24 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-60px" }}
                transition={{ duration: 0.5, delay: (i % 6) * 0.06 }}
                data-testid={`service-card-${s.code.toLowerCase()}`}
                className={`${s.span} group relative bg-obsidian text-left p-6 sm:p-8 flex flex-col justify-between min-h-[170px] hover:bg-olive-deep/60 transition-colors duration-300`}
              >
                <div className="flex items-start justify-between">
                  <Icon className="w-7 h-7 text-khaki group-hover:text-alert transition-colors duration-300" strokeWidth={1.5} />
                  <span className="text-[10px] tracking-[0.25em] text-coyote">{s.code}</span>
                </div>
                <div className="mt-8">
                  <span className="text-[9px] tracking-[0.3em] text-coyote group-hover:text-khaki transition-colors duration-300">
                    {s.category}
                  </span>
                  <h3 className="mt-1 text-sm sm:text-base font-bold text-foreground leading-snug group-hover:text-white transition-colors duration-300">
                    {s.name}
                  </h3>
                  <span className="mt-3 inline-block text-[10px] tracking-[0.25em] text-alert opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                    &gt;&gt; DEPLOY THIS UNIT
                  </span>
                </div>
              </motion.button>
            );
          })}
        </div>
        <p className="mt-6 text-[11px] tracking-[0.2em] text-coyote" data-testid="services-count">
          SHOWING {visible.length} OF {SERVICES.length} OPERATIONS — SELECT A UNIT TO PRE-LOAD THE REQUEST FORM
        </p>
      </div>
    </section>
  );
};
